import { jsx as r, Fragment as i, jsxs as s } from "@emotion/react/jsx-runtime";
import { ThumbContainer as c, ThumbInner as p, RemoveThumb as d } from "./Thumbs.styled.js";
import { FontAwesomeIconsPartooUsed as h } from "../../../types/components/icon.js";
const T = ({
  files: a,
  removeFile: n,
  width: m
}) => {
  const t = (e, o) => {
    e.stopPropagation(), n(o);
  };
  return /* @__PURE__ */ r(i, { children: a.map((e) => /* @__PURE__ */ s(c, { width: m, children: [
    /* @__PURE__ */ r(p, { imageSrc: e.preview, onLoad: () => {
      URL.revokeObjectURL(e.preview);
    } }),
    /* @__PURE__ */ r(d, { dataTrackId: "remove_file__dropzone", "aria-label": "Remove file", size: "small", appearance: "contained", variant: "danger", icon: [h.faTrash], onClick: (o) => t(o, e.name) })
  ] }, e.name)) });
};
export {
  T as Thumbs
};
